<script setup>

import {computed} from "vue";

const props = defineProps({
    newsletter: {
        type: Object,
        required: true
    }
})

</script>

<template>
    <div
        class="grid md:grid-cols-2 gap-8"
    >
        <div>
            <input-label :label="_mft('communication:tags.assignedBetweenDates.startDate')" />

            <input-datepicker
                name="date"
                :date="newsletter.once_assigned_in_time_range_start"
                :minDate="null"
                :rangeMode="false"
                :showTime="false"
                @update:date="newsletter.once_assigned_in_time_range_start = $event"
                class="w-full mt-1"
            />
        </div>

        <div>
            <input-label :label="_mft('communication:tags.assignedBetweenDates.endDate')" />

            <input-datepicker
                name="date"
                :date="newsletter.once_assigned_in_time_range_end"
                :minDate="null"
                :rangeMode="false"
                :showTime="false"
                @update:date="newsletter.once_assigned_in_time_range_end = $event"
                class="w-full mt-1"
            />
        </div>

    </div>

</template>

<style scoped>

</style>
